import {FC} from "react";
import {useTranslation} from "react-i18next";
import {Badge} from "@interstate/components/Badge";
import {CheckCircleIcon, ShieldSolidIcon} from "@interstate/components/Icons";
import {
  isClientEntityComplex,
  isClientEntityOperational
} from "@common-core/coat-operational-hierarchy-appsync-model";
import {useInterstateToken} from "@interstate/components/InterstateThemeProvider";
import {BadgeBar} from "../../../../../badges";
import {OperationalEntityPopover} from "../../../../hierarchy";
import {CreatePlanNodeLabelProps} from "../common";
import "../common/CreateTreeNodeLabel.scss";

export const SelectSourcesStepNodeLabel: FC<CreatePlanNodeLabelProps> = ({
  node
}) => {
  const {t} = useTranslation();
  const token = useInterstateToken();
  const complex = isClientEntityComplex(node.source);
  const operational = isClientEntityOperational(node.source);

  return (
    <div
      id={`create-plan-node-label-${node.caId}`}
      data-testid={`create-plan-node-label-${node.caId}`}
      className={"create-tree-node-label create-plan-node-label"}>
      <div className={"cust-name"}>
        <span>{node.source.custName}</span>
      </div>
      <BadgeBar>
        {complex && (
          <Badge
            id={`create-plan-node-complex-badge-${node.caId}`}
            data-testid={`create-plan-node-complex-badge-${node.caId}`}
            className={"create-plan-node-badge create-plan-node-complex-badge"}
            variant={"info"}
            startIcon={<ShieldSolidIcon />}>
            <span className={"create-plan-node-badge-label"}>
              {t("create-operational-hierarchy.entity-states.complex")}
            </span>
          </Badge>
        )}
        {operational && (
          <OperationalEntityPopover
            caId={node.caId}
            operationalEntities={node.source.mappedOperationalEntities || []}>
            <Badge
              id={`create-plan-node-operational-badge-${node.caId}`}
              data-testid={`create-plan-node-operational-badge-${node.caId}`}
              className={
                "create-plan-node-badge create-plan-node-operational-badge"
              }
              variant={"transparent"}
              startIcon={
                <CheckCircleIcon
                  color={token("sem.color.on-surface.success.muted")}
                />
              }>
              <span className={"create-plan-node-badge-label"}>
                {t("create-operational-hierarchy.entity-states.operational")}
              </span>
            </Badge>
          </OperationalEntityPopover>
        )}
      </BadgeBar>
    </div>
  );
};
